import { base_img, EVENTS, PRODUCT_TYPES } from './constants';
import _ from 'lodash';
import EventBus from './event-bus';
import { Route } from '../../types';
// import ShopService from './shop-service';


let UrlService = {
	isInAdmin,
	isInManager,
	href,
	imagePath,
	dashifyItem,
	dashify,
	slugify,
	urlFor,
	currentForTreeItem,
	itemHref,
	getBasePath,
	go,
	replace,
	path,
	includes,
	get params(): { [key: string]: any } {
		if (window.vueInstance) {
			return _.clone(window.vueInstance.$route?.params);
		}
		let $stateParams = getFromAngular('$stateParams');
		return _.clone($stateParams);
	},
	current,
	angularLoaded,
	fromQuery,
	setQueryParam,
};


export default UrlService;

function isInAdmin() {
	return UrlService.includes("admin") || UrlService.includes("admin1") || UrlService.includes("admin2");
}
function isInManager() {
	return UrlService.includes("manager");
}
let $injector;
function angularLoaded(_$injector) {
	$injector = _$injector;
	console.log('ng loaded', $injector === window.injector);
	let $rootScope = $injector.get('$rootScope');
	$rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) =>
		setTimeout(() => EventBus.$emit(EVENTS.route.after, { name: toState.name, params: toParams }, { name: fromState.name, params: fromParams })));
	$rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) =>
		EventBus.$emit(EVENTS.route.before, { name: toState.name, params: toParams }, { name: fromState.name, params: fromParams }));
}

function fromQuery(queryString = window.location.search): { [key: string]: string } {
	return Object.fromEntries(new URLSearchParams(queryString))
}

function setQueryParam(key: string, value: string) {
	let searchParams = new URLSearchParams(window.location.search)
	if (value !== undefined) {
		searchParams.set(key, value);
	} else {
		searchParams.delete(key);
	}
	let query = searchParams.toString();
	let newRelativePathQuery = window.location.pathname + (query ? '?' : '') + query;
	history.pushState(null, '', newRelativePathQuery);
}

function current() {
	if (window.vueInstance) {
		return _.clone(window.vueInstance.$route);
	}
	let $state = getFromAngular('$state');
	return {
		name: $state.current.name,
		params: UrlService.params,
		meta: $state.current.data,
	};
}

function path(newPath = null) {
	let pathname = location.pathname;
	// trim document.baseURI
	let base = document.baseURI.substring(location.origin.length, document.baseURI.length - 1);
	if (newPath) {
		location.pathname = base + newPath;
	}
	return pathname.substr(base.length);
}

function replace(route: Route) {
	if (window.vueInstance) {
		window.vueInstance.$router?.replace(route);
		return;
	}
	let $state = getFromAngular('$state');
	$state.go(route.name, route.params, { location: 'replace' });
}

// console.log('import url-service')
function go(route: Route = null, onComplete: Function = null) {
	// console.log('url-service:go()')
	if (_.isString(route)) {
		throw new Error(route + ' must be of type Route');
	}
	// if (!window.injector) {
	// 	setTimeout(_ => {
	// 		go(route)
	// 	});
	// 	return;
	// }
	if (window.vueInstance) {
		window.vueInstance.$router?.push(route, onComplete);
		return;
	}
	let $state = getFromAngular('$state');
	let $stateParams = getFromAngular('$stateParams');
	let $location = getFromAngular('$location');
	let promise;
	if (!route) {
		promise = $state.go($state.current.name, $stateParams, { reload: true }); // force reload
	} else if (route.name) {
		promise = $state.go(route.name, route.params);
	} else {
		if (onComplete) {
			console.error('onComplete callback is not supported for Route.path');
		}
		$location.path(route.path);
	}
	if (onComplete && promise) {
		promise.then(onComplete);
	}
}

function getFromAngular(provider: string) {
	let injector = window.injector;
	if (!injector) return null;
	return injector.get(provider);
}

function includes(routePath: string) {
	if (window.vueInstance) {
		for (let i in window.vueInstance.$route?.matched) {
			let path = window.vueInstance.$route.matched[i].path
			if (path[0] == '/') path = path.substr(1);
			if (path == routePath) return true;
		}
		return false;
	}
	let $state = getFromAngular('$state');
	if (!$state) console.warn('$state is null !');
	return $state?.includes(routePath);
}

function href(route: Route) {
	if (window.vueInstance) {
		return window.vueInstance.$router?.resolve(route).href;
	}
	let $state = getFromAngular('$state');
	return $state.href(route.name, route.params);
}

function imagePath(ShopId: number, filename: string) {
	if (!filename) return " ";
	if (filename.startsWith('blob:')) return filename;
	if (filename.startsWith('http:')) return filename;
	if (filename.startsWith('https:')) return filename;
	if (window.location.hostname == 'localhost') {
		return 'img/' + ShopId + '/' + filename;
	}
	return base_img + ShopId + '/' + filename;
}

// function productImage(obj: {ShopId }, field = 'ims') {
// 	return imagePath(obj.ShopId, field);
// }

function getBasePath() {
	let a = document.createElement("a");
	a.href = "";
	return a.href;
}

function itemHref(item, shop = null) {
	let itemSlug = dashifyItem(item);
	let ShopId = shop && shop.ShopId || UrlService.params.ShopId;
	return '' + ShopId + '/carte/' + item.tid + '/#' + itemSlug;
}

function dashifyItem(item) {
	return item && (item.tid + '-' + dashify(item.product?.dn)) || '';
}

function dashify(str = "") {
	return str && str.replace(/[ _]/g, '-').replace(/[^-\w]/g, '');
}
function slugify(item) {
	var itemPath = []
	while (item.parent) {
		itemPath.unshift(item.product.dn)
		item = item.parent
	}
	return itemPath.join('/').replace(/ /g, '-').replace(/_/g, '-')
}

function urlFor(item) {
	var path = slugify(item)
	let url;
	if (includes('admin2')) {
		url = href({ name: 'admin2.carte.current', params: { tid: item.tid, path: path } });
	} else if (includes('admin1')) {
		url = href({ name: 'admin1.carte.current', params: { tid: item.tid, path: path } });
	} else {
		url = href({ name: 'carte.current', params: { tid: item.tid, path: path } });
	}
	let base = this.getBasePath().replace(location.origin, '');
	if (url && url.startsWith(base)) {
		url = url.replace(base, '');
	}
	if (url && url.startsWith('/')) {
		url = url.replace('/', '');
	}
	return url;
}

function currentForTreeItem(treeItem) {
	var current = {
		treeItem: treeItem,
		product: treeItem && treeItem.product,
		join_option: _.head(treeItem && treeItem.product.options),
		joinPrices: treeItem.product.joinPrices,
	}

	return current
}
